import React, { useContext, useState } from "react";
import { UrlContext } from "../../contexts/UrlContext";
export default function SelectButtonForList({ list_id, exp_id }) {
  const [showSelect, setShowSelect] = useState(true);
  const tokenObj = localStorage.getItem("eph-token");
  const token = JSON.parse(tokenObj).value;
  const { API_URL } = useContext(UrlContext);

  const handleSelect = () => {
    const url = `${API_URL}select-expert-from-list/${list_id}/${exp_id}`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setShowSelect(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUnselect = () => {
    const url = `${API_URL}unselect-expert-from-list/${list_id}/${exp_id}`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setShowSelect(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      {showSelect ? (
        <button className="btn select-profile-btn" onClick={handleSelect}>
          <i className="fa-solid fa-user-plus" /> Select
        </button>
      ) : (
        <button className="btn unselect-profile-btn" onClick={handleUnselect}>
          Unselect
        </button>
      )}
    </>
  );
}
